import SeleccionUsuario from './seleccion-usuario.vue'

export default {
	install: Vue => {
		Vue.component('seleccion-usuario', SeleccionUsuario)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/components/seleccion-usuario/seleccion-usuario.js